module.exports = __webpack_public_path__ + "img/geofisica_9-16_540.9d1eeb40.jpg";